import OptIn from '../OptIn/OptIn.class';

export default class ExperimentAOptInPopUp extends OptIn {
}
